import React from "react";

// STYLES
import * as Style from "./UserProfileStyle";

// LIBRARIES

// MISC
import { IProps } from "./UserProfileModel";

// ASSETS

// REDUX

// COMPONENTS

const NewcomeUser = (props: IProps) => {

  // PROPS
  const { user = null, handleSelect = () => {} } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.UserContainer>
      <Style.VerticalLine />
      <Style.UserImage src={user.imagePath} alt=""/>
      <Style.UserInfo>
        <Style.UserName>{`${user?.firstName || ""} ${user?.lastName || ""}`}</Style.UserName>
        <Style.UserStatus>
          <Style.CheckboxContainer
            checked={user?.isSelected || ""}
            onClick={() => handleSelect(user)}
          />
          <Style.Text>Selecteaza</Style.Text>
        </Style.UserStatus>
      </Style.UserInfo>
    </Style.UserContainer>
  );
};

export default NewcomeUser;
